<template>
    <div>
      <iframe id="iframeReport" name="iframeReport" style="height: 0; width: 0"></iframe>
      <section ref="invoice" style="display: none" id="printableAreas">
        <v-banner style="text-align:center;" class="subtitle"> Teacher Report </v-banner>

         <div v-for="(item, key) in classWiseModules" :key="key">
          <v-row>
            <v-col>Class Name : {{ key }}</v-col>
            <v-col>Total teacher count : {{ teacherCount[key] !== undefined ? teacherCount[key] : item.uniqueEmailCount }}</v-col>
          </v-row>
         <v-row>
            <v-col> Parameter :{{  getParameter(key)  }} </v-col>
            <v-col> Modules : {{ getModule(key) }} </v-col>
         </v-row>

            <div class="relative">
              <br />

              <img :src="graphImages[key]" alt="" />
            </div>

          <v-divider></v-divider>
        </div>
      </section>
    </div>
  </template>

<script>
export default {
  name: 'OnlineClassList',
  props: ['scaleList', 'graphImages', 'classWiseModules', 'parameter', 'module', 'teacherCount'],
  components: {},
  data () {
    return {
      prtHtml: '',
      report: []
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  methods: {
    seriesCount: function (report) {
      let temp = []
      this.scaleList.forEach((scale) => {
        let scaleName = scale.gradeScale
        if (report.hasOwnProperty(scaleName)) {
          temp.push(parseFloat(report[scaleName]))
        } else {
          temp.push(0)
        }
      })
      return temp
    },
    getParameter (key) {
      if (this.parameter[key] && this.parameter[key] !== undefined && this.parameter[key]?.length > 0) {
        return this.parameter[key]?.join(' , ')
      } else {
        return 'ALL'
      }
    },
    getModule (key) {
      if (this.module[key] && this.module[key] !== undefined && this.module[key]?.length > 0) {
        return this.module[key]?.map(scale => scale.module)?.join(' , ')
      } else {
        return 'ALL'
      }
    }

  }
}
</script>
  <style scoped>
  @media print {
    #printableAreas,
    #printableAreas * {
      visibility: visible;
    }
    #printableAreas {
      position: absolute;
      left: 0;
      top: 0;
    }
    #printableAreas1,
    #printableAreas1 * {
      visibility: visible;
    }
    #printableAreas1 {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  </style>
